import { useState } from 'react'
import { Briefcase } from 'lucide-react'
import { cn } from '@/utils/cn'
import { MapaCargosTab } from '@/components/Configuracao/mapaCargos/MapaCargosTab'

type GestaoSubTab = 'mapa-cargos'

export function GestaoTab() {
  const [subTab, setSubTab] = useState<GestaoSubTab>('mapa-cargos')

  return (
    <div className='space-y-4'>
      <div className='glass-card p-5'>
        <div className='flex w-fit items-center gap-1 rounded-lg border border-white/[0.06] bg-white/[0.04] p-1'>
          <button
            type='button'
            onClick={() => setSubTab('mapa-cargos')}
            className={cn(
              'flex min-h-[44px] items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-bold transition-all',
              subTab === 'mapa-cargos'
                ? 'bg-accent text-white shadow-lg shadow-accent/20'
                : 'text-text-muted hover:bg-white/[0.06] hover:text-text-primary',
            )}
          >
            <Briefcase size={13} />
            Mapa de Cargos
          </button>
        </div>
      </div>

      <div className='mt-4'>
        {subTab === 'mapa-cargos' && <MapaCargosTab />}
      </div>
    </div>
  )
}
